<template>
  <SharedMapDialogView
    :show-dialog="showDialog"
    message="Choose the fields to refresh:"
  >
    <template #dialog-container>
      <LoadIcon
        v-if="loading"
        style="margin: auto;"
        :size="40"
      />
      <div
        v-else-if="loadFailed"
        data-testid="load-failed"
      >
        Could not load the fields to refresh from Beyond Maps.
      </div>
      <div v-else>
        <RefreshFeatureSettings
          :collections="[]"
          :refresh-field-settings="refreshFieldSettings"
          :tabs="tabs"
          @set-settings="setRefreshSettings"
        />
        <np-action-btn
          class="mt-4 float-right"
          :loading="loadingRefresh"
          @click="$emit('refresh-markers', refreshFieldSettings)"
        >
          Refresh Markers
        </np-action-btn>
      </div>
    </template>
  </SharedMapDialogView>
</template>

<script lang="ts">
import SharedMapDialogView from '@/internal/components/FilterMenu/sections/UpsertSharedMap/SharedMapDialogView.vue';
import RefreshFeatureSettings from './RefreshFeatureSettings.vue';
import LoadIcon from '@/components/svgs/LoadIcon.vue';

import {getRefreshFeatureSettings} from '@/services/RefreshService/RefreshFeatures';
import {mapMutations, mapState} from 'vuex';
import {SharedMap} from '@/lib/classes/SharedMap';
import {RefreshFieldSettings, RefreshTab} from '@/services/RefreshService/types';
import {wrapError} from '@northpoint-development/labs-common-core';

export default {
  name: 'RefreshFeaturesDialog',
  components: {
    SharedMapDialogView,
    RefreshFeatureSettings,
    LoadIcon,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    loadingRefresh: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['refresh-markers'],
  data() {
    return {
      loading: false,
      loadFailed: false,
      tooltipText: 'No markers with Beyond Maps IDs to refresh',
      tabs: [] as RefreshTab[],
      refreshFieldSettings: new Map() as RefreshFieldSettings,
    };
  },
  computed: {
    ...mapState({sharedMap: (state: any) => state.sharedMap as SharedMap}),
  },
  watch: {
    async showDialog(newVal: boolean) {
      if (newVal) {
        this.loading = true;
        this.loadFailed = false;
        try {
          const {tabs, refreshFieldSettings} = await getRefreshFeatureSettings(this.sharedMap);
          this.tabs = tabs;
          this.refreshFieldSettings = refreshFieldSettings;
        } catch (error) {
          console.error(wrapError(error, 'Error fetching refresh feature settings'));
          this.loadFailed = true;
          this.setSnack({
            message: 'An error occurred while loading the fields to refresh.',
            duration: 5000,
            color: 'error',
          });
        }
        this.loading = false;
      }
    },
  },
  methods: {
    ...mapMutations(['setSnack']),
    setRefreshSettings(settings: RefreshFieldSettings) {
      this.refreshFieldSettings = settings;
    },
  },

};
</script>
